/**
 * Полная очистка redux-persist и сброс store
 */
export async function clearPersistAndStore() {
  const { persistor, store, resetStore } = await import('@store/store');
  await persistor.purge();
  store.dispatch(resetStore());
}
